export default {
  id: 45,
  title: 'Target #45 - Magical Tree',
  url: 'https://cssbattle.dev/play/45',
  colors: ['#1A4341', '#F3AC3C', '#998235'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#1A4341}a{position:fixed}a[a]{top:-30;left:125;width:90;height:120;border:30px solid #998235}a[b],a[c]{left:65}a[b]{top:240;width:270;height:30;background:#998235}a[c]{top:-30;width:210;height:180;border:30px solid #F3AC3C}a[d]{top:0;left:185;width:30;height:300;background:#F3AC3C}</style>',
}
